import { observer } from 'mobx-react';
import React from 'react';
import { Tracker } from '@udemy/event-tracking';
import { SubscriptionPlanProductType } from '@udemy/graphql';
import { useI18n } from '@udemy/i18n';
import { SubscriptionLearnMoreEvent } from '../../../events';
import { useSubscribe } from '../../../hooks/use-subscribe';
import { MobileNavItem } from '../mobile-nav.react-component';
export const MobileSubscribeButton = observer(props => {
  const {
    gettext
  } = useI18n();
  const {
    subscribeUrl,
    showSubscribeButton
  } = useSubscribe();
  if (!showSubscribeButton) {
    return null;
  }
  const handleClick = () => {
    Tracker.publishEvent(new SubscriptionLearnMoreEvent('289661', SubscriptionPlanProductType.Consumersubscription, 'mobile_nav'));
  };
  return /*#__PURE__*/React.createElement(MobileNavItem, Object.assign({}, props, {
    href: subscribeUrl,
    "data-testid": "mobile-subscribe-button",
    onClick: handleClick
  }), gettext('Subscribe'));
});
//# sourceMappingURL=mobile-subscribe-button.react-component.js.map